import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://feedpager.herokuapp.com/api/'
});

export default instance;